module.exports = __webpack_public_path__ + "img/SoMe.8bc6ad23.jpg";